"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderHeader = exports.HeaderLoader = void 0;
var react_1 = __importStar(require("react"));
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var client_1 = require("@apollo/client");
var util_1 = require("@aperza/util");
var Header_1 = __importDefault(require("./Header"));
var UserSection_1 = __importDefault(require("../user/UserSection"));
var NavBar_1 = __importDefault(require("../navbar/NavBar"));
var react_dom_1 = __importDefault(require("react-dom"));
var QUERY = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query HeaderLoaderQuery($params: String!) {\n    viewer {\n      id\n      aperzaId\n      userId\n      cartBadge {\n        approvalFlag\n        totalPurchaseNumber\n      }\n      searchModel(params: $params) {\n        count\n      }\n      searchItem(params: $params) {\n        count\n      }\n      searchCatalog(params: $params) {\n        count\n      }\n      searchNews(params: $params) {\n        count\n      }\n      ...UserSection_viewer\n      ...NavBar_viewer\n    }\n  }\n  ", "\n  ", "\n"], ["\n  query HeaderLoaderQuery($params: String!) {\n    viewer {\n      id\n      aperzaId\n      userId\n      cartBadge {\n        approvalFlag\n        totalPurchaseNumber\n      }\n      searchModel(params: $params) {\n        count\n      }\n      searchItem(params: $params) {\n        count\n      }\n      searchCatalog(params: $params) {\n        count\n      }\n      searchNews(params: $params) {\n        count\n      }\n      ...UserSection_viewer\n      ...NavBar_viewer\n    }\n  }\n  ", "\n  ", "\n"])), UserSection_1.default.fragments.viewer, NavBar_1.default.fragments.viewer);
var HeaderLoader = function (props) {
    var _a = client_1.useQuery(QUERY, {
        variables: {
            params: JSON.stringify(util_1.AppConfigService.getSearchParams() || {}),
        },
    }), loading = _a.loading, error = _a.error, data = _a.data, refetch = _a.refetch;
    if (loading)
        return react_1.default.createElement("div", null, "LOADING");
    if (!loading || data) {
        var initEl = document.getElementById('aperza-header-init');
        if (initEl) {
            initEl.style.display = 'none';
        }
    }
    var headerProps = __assign(__assign({}, util_1.AppConfigService.resolveHeaderConfigurations()), props);
    var doRefetch = function () {
        if (refetch) {
            return refetch({
                params: JSON.stringify(util_1.AppConfigService.getSearchParams() || {}),
            });
        }
    };
    //return <div>HELLO</div>;
    return react_1.default.createElement(Header_1.default, __assign({ viewer: data.viewer, refetch: doRefetch }, headerProps));
};
exports.HeaderLoader = HeaderLoader;
exports.default = HeaderLoader;
var renderHeader = function (apolloClient) {
    var headerElement = document.getElementById('aperza-header');
    if (headerElement) {
        react_dom_1.default.render(react_1.default.createElement(client_1.ApolloProvider, { client: apolloClient },
            react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null) },
                react_1.default.createElement(HeaderLoader, null))), headerElement);
    }
};
exports.renderHeader = renderHeader;
var templateObject_1;
